// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__3N1KK","loading":"Image_loading__2vQXo"};